const filterServicesCatalog = (catalog, filter) => catalog.reduce((categories, category) => {
    const subcategories = category.categories.reduce(
      (subcategories, subcategory) => {
        const services = subcategory.services.filter(filter);

        if (services.length === 0) {
          return subcategories;
        }

        return subcategories.concat({
          ...subcategory,
          services,
        });
      },
      []
    );

    if (subcategories.length === 0) {
      return categories;
    }

    return categories.concat({
      ...category,
      categories: subcategories,
      servicesCount: subcategories.reduce((count, subcategory) => count + subcategory.services.length, 0),
    });
  }, []);

export default filterServicesCatalog;
